import { render, staticRenderFns } from "./ModalOrderNotes.vue?vue&type=template&id=74076d3e&scoped=true"
import script from "./ModalOrderNotes.vue?vue&type=script&lang=js"
export * from "./ModalOrderNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74076d3e",
  null
  
)

export default component.exports